var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { default as React, useState } from 'react';
import { ButtonVariant } from '../Components/Button';
import { StyledDialog } from '../Components/Dialog/StyledDialog';
import { StyledDialogButton } from '../Components/Dialog/StyledDialogButton';
import { displayError, displayMessage } from '../Config/ApplicationConfig';
import { cancelPharmacyRequestByPatientAuthKeys } from '../Async/PharmacyRequestsAsync';
import styles from './CancelPharmacyRequestDialog.module.css';
import moment from 'moment-timezone';
import { ValidDateFormats } from '../Shared/DateUtilities';
import { MaskedTextField } from '../Components/MaskedTextField';
export var CancelPharmacyRequestDialog = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    var _m = __read(useState(false), 2), cancelling = _m[0], setCancelling = _m[1];
    var _o = __read(useState(''), 2), reason = _o[0], setInputValue = _o[1];
    var callCancelPharmacyRequest = function () { return __awaiter(void 0, void 0, void 0, function () {
        var convertToLookup, cancelRequest;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    convertToLookup = function (request) {
                        var _a, _b, _c;
                        return {
                            id: (_a = request === null || request === void 0 ? void 0 : request.id) !== null && _a !== void 0 ? _a : '',
                            authoringSystem: (_b = request === null || request === void 0 ? void 0 : request.authoringSystem) !== null && _b !== void 0 ? _b : '',
                            authoringSystemForeignKey: (_c = request === null || request === void 0 ? void 0 : request.authoringSystemForeignKey) !== null && _c !== void 0 ? _c : ''
                        };
                    };
                    cancelRequest = {
                        pharmacyRequest: convertToLookup(props.pharmacyRequest),
                        cancelledOn: moment().format(ValidDateFormats.NodeDateTimeTimezone),
                        reason: reason
                    };
                    return [4 /*yield*/, cancelPharmacyRequestByPatientAuthKeys(props.patient.authoringSystem, props.patient.authoringSystemForeignKey, cancelRequest)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var cancelPharmacyRequest = function () { return __awaiter(void 0, void 0, void 0, function () {
        var e_1;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    setCancelling(true);
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, callCancelPharmacyRequest()];
                case 2:
                    _d.sent();
                    displayMessage(((_a = props.pharmacyRequestTerm) === null || _a === void 0 ? void 0 : _a.singularTerm) + " cancelled");
                    setCancelling(false);
                    props.onCancel();
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _d.sent();
                    setCancelling(false);
                    props.onClose();
                    displayError("Unable to cancel " + ((_c = (_b = props.pharmacyRequestTerm) === null || _b === void 0 ? void 0 : _b.singularTerm) === null || _c === void 0 ? void 0 : _c.toLowerCase()));
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement(StyledDialog, { open: true, size: 'xs', modal: true, testId: 'cancel-pharmacy-request', title: "Cancel " + ((_b = (_a = props.pharmacyRequestTerm) === null || _a === void 0 ? void 0 : _a.singularTerm) === null || _b === void 0 ? void 0 : _b.toLowerCase()), closeFunction: function () { return props.onClose(); }, actions: [
            React.createElement(StyledDialogButton, { variant: ButtonVariant.light, key: 'cancel', disabled: cancelling, testId: 'cancel-pharmacy-request-cancel', onClick: function () { return props.onClose(); } }, "Cancel"),
            React.createElement(StyledDialogButton, { variant: ButtonVariant.primary, key: 'continue', disabled: cancelling, testId: 'cancel-pharmacy-request-confirm', onClick: cancelPharmacyRequest }, "Continue")
        ], contentComponent: React.createElement("div", { className: styles.container },
            React.createElement("div", { className: styles.heading }, "Are you sure you want to cancel " + ((_d = (_c = props.pharmacyRequestTerm) === null || _c === void 0 ? void 0 : _c.singularTerm) === null || _d === void 0 ? void 0 : _d.toLowerCase()) + " #" + ((_f = (_e = props.pharmacyRequest) === null || _e === void 0 ? void 0 : _e.requestNumber) !== null && _f !== void 0 ? _f : "no " + ((_h = (_g = props.pharmacyRequestTerm) === null || _g === void 0 ? void 0 : _g.abbreviatedSingularTerm) === null || _h === void 0 ? void 0 : _h.toLowerCase()) + " number found") + "?"),
            React.createElement("div", null,
                React.createElement(MaskedTextField, { name: 'cancelReason', label: 'Cancellation reason', testId: 'cancel-pharmacy-request-dialog-reason', autoFocus: true, disabled: cancelling, helperText: '', value: reason, onChange: function (value) { return setInputValue(value); } })),
            React.createElement("div", { className: styles.line }),
            React.createElement("span", { className: styles.text },
                "This ", (_k = (_j = props.pharmacyRequestTerm) === null || _j === void 0 ? void 0 : _j.singularTerm) === null || _k === void 0 ? void 0 :
                _k.toLowerCase(),
                " includes the following medications:"),
            React.createElement("ul", { className: styles.list }, (_l = props.pharmacyRequest) === null || _l === void 0 ? void 0 : _l.pharmacyRequestItems.map(function (x, index) { return (React.createElement("li", { className: styles.listItem, key: x.id + "-" + index }, x.name)); }))) }));
};
